import PropTypes from "prop-types";
import ProductImage from "../../../../../ProductImage";
import LazyProductHeroContainer from "../../../../../LazyProductHeroContainer";
import styles from "./index.css";
import classnames from "classnames";
import { forwardRef, useState } from "react";

const ImageGalleryContainer = forwardRef(
  (
    {
      primaryImageProps,
      children,
      onTouchStart,
      onAnimationEnd,
      onTouchImages,
      className
    },
    ref
  ) => {
    const [loadOnTouchImages, setLoadOnTouchImages] = useState(false);

    return (
      <div
        className={classnames(styles.imageGalleryContainer, className)}
        onTouchStart={() => {
          setLoadOnTouchImages(true);
          onTouchStart();
        }}
        ref={ref}
        onAnimationEnd={onAnimationEnd}
      >
        <ProductImage {...primaryImageProps} />
        {children}
        {loadOnTouchImages &&
          onTouchImages.map(imageUrl => (
            <LazyProductHeroContainer
              key={imageUrl}
              doLoad={true}
              render={lazyProps => (
                <ProductImage
                  {...{
                    imageUrl,
                    ...lazyProps
                  }}
                />
              )}
            />
          ))}
      </div>
    );
  }
);

ImageGalleryContainer.displayName = "ImageGalleryContainer";

ImageGalleryContainer.propTypes = {
  primaryImageProps: PropTypes.shape({
    imageUrl: PropTypes.string.isRequired,
    onLoad: PropTypes.func,
    className: PropTypes.string,
    onTransitionEnd: PropTypes.func
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  onTouchStart: PropTypes.func.isRequired,
  onAnimationEnd: PropTypes.func,
  onTouchImages: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string
};

export default ImageGalleryContainer;
